import $ from 'jquery';
import 'slick-carousel';

$(document).ready(function() {
  function initCard2() {
    if ($(window).width() <= 960) {
      if ($('.ucg-card-2-block .images').length) {
        if ($('.ucg-card-2-block .images').find('.image-2').length) {
          $('.ucg-card-2-block .images').not('.slick-initialized').slick({
            arrows: true,
            autoplay: false,
            autoplaySpeed: 5000,
            cssEase: 'ease-out',
            infinite: false,
            nextArrow: '<p class="slick-next"><i class="fa fa-arrow-right"></i></p>',
            pauseOnHover: false,
            pauseonFocus: false,
            prevArrow: '<p class="slick-prev"><i class="fa fa-arrow-left"></i></p>',
            slidesToShow: 1.25,
            slidesToScroll: 1,
            speed: 1000
          });
        }
      }
    } else {
      $('.ucg-card-2-block .images.slick-initialized').slick('unslick')
    }
  }
  initCard2();
  $(window).on('load, resize', function() {
    initCard2()
  })
})